import React, { FC } from 'react'
import { Box } from '@moonpig/launchpad-components'
import { BulletedLocationListItem } from './BulletedLocationListItem'

export const ListedLocations: FC<{
  postcodesByCity: Record<string, string[]>
}> = ({ postcodesByCity }) => {
  return (
    <Box pb={6} width={1}>
      <BulletedLocationListItem postcodesByCity={postcodesByCity} />
    </Box>
  )
}
